import { Lock } from "lucide-react";

export default function Privacidade() {
  return (
    <div className="min-h-screen bg-[#050B14] text-slate-100">
      <div className="max-w-3xl mx-auto px-6 py-24">
        <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-white/10 bg-white/[0.04] text-[11px] font-semibold uppercase tracking-[0.2em] text-blue-300 mb-8">
          <Lock className="h-3.5 w-3.5" />
          Política de Privacidade
        </div>

        <h1 className="text-4xl sm:text-5xl font-semibold tracking-tighter text-white leading-[1.05] mb-4">
          Política de Privacidade
        </h1>
        <p className="text-slate-400 text-lg mb-12">Última actualização: Maio de 2026</p>

        <div className="space-y-10 text-slate-300 leading-relaxed">

          <Section title="Quem somos">
            <p>A Automia é uma plataforma de automação de atendimento e marcações via WhatsApp. Este documento explica como recolhemos, usamos e protegemos os seus dados pessoais quando visita o nosso site ou utiliza o nosso serviço.</p>
          </Section>

          <Section title="Dados que recolhemos">
            <p>Recolhemos apenas os dados estritamente necessários para prestar o serviço:</p>
            <ul className="list-disc list-inside mt-3 space-y-1 text-slate-400">
              <li>Nome e endereço de e-mail (ao preencher o formulário de contacto)</li>
              <li>Número de telemóvel (opcional, para contacto)</li>
              <li>Nome da empresa e descrição do negócio</li>
              <li>Dados de navegação anónimos (páginas visitadas, tempo no site)</li>
            </ul>
          </Section>

          <Section title="Como usamos os seus dados">
            <p>Os seus dados são utilizados exclusivamente para:</p>
            <ul className="list-disc list-inside mt-3 space-y-1 text-slate-400">
              <li>Responder ao seu pedido de contacto ou demonstração</li>
              <li>Configurar e prestar o serviço Automia</li>
              <li>Enviar informações relevantes sobre o serviço (com o seu consentimento)</li>
              <li>Melhorar a nossa plataforma com base em dados agregados e anónimos</li>
            </ul>
          </Section>

          <Section title="Partilha de dados">
            <p>Não vendemos, alugamos nem partilhamos os seus dados pessoais com terceiros para fins comerciais. Podemos partilhar dados com fornecedores de infraestrutura (ex: servidores) que actuam como subcontratantes e estão vinculados por acordos de confidencialidade.</p>
          </Section>

          <Section title="Cookies">
            <p>O nosso site pode utilizar cookies técnicos necessários ao seu funcionamento. Não utilizamos cookies de rastreamento ou publicidade sem o seu consentimento explícito.</p>
          </Section>

          <Section title="Os seus direitos">
            <p>Tem direito a aceder, corrigir, apagar ou exportar os seus dados a qualquer momento. Para exercer estes direitos, contacte-nos em <a href="mailto:ola@automia.pt" className="text-blue-400 hover:text-blue-300">ola@automia.pt</a>.</p>
          </Section>

          <Section title="Segurança">
            <p>Adoptamos medidas técnicas e organizativas adequadas para proteger os seus dados contra acesso não autorizado, perda ou alteração. Toda a comunicação é cifrada via TLS.</p>
          </Section>

          <Section title="Contacto">
            <p>Para qualquer questão sobre esta política: <a href="mailto:ola@automia.pt" className="text-blue-400 hover:text-blue-300">ola@automia.pt</a></p>
          </Section>

        </div>

        <div className="mt-16 pt-8 border-t border-white/10">
          <a href="/" className="text-sm text-slate-400 hover:text-white transition-colors">← Voltar ao início</a>
        </div>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div>
      <h2 className="text-xl font-medium text-white mb-3">{title}</h2>
      {children}
    </div>
  );
}
